/*eslint-disable*/
$(document).ready(function () {
    jcf.setOptions('Select', {
        wrapNative: false,
        wrapNativeOnMobile: true,
        maxVisibleItems: 5,
        multipleCompactStyle: true,
    });

    $('.jcf')
        .not('.Taxonomy__select,.primary__subject, .advanced-search select.jcf')
        .each(function () {
            jcf.replace($(this));
        });

    jcf.setOptions('Select', {
        maxVisibleItems: 12,
    });

    jcf.replace('.Taxonomy__select, .advanced-search select.jcf');

    jcf.setOptions('Select', {
        maxVisibleItems: 10,
    });

    jcf.replace('.primary__subject');
});
